import React, { FC, useEffect, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    ImageList,
    ImageListItem,
    Box,
    Paper,
    LinearProgress,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type ImageGalleryDialogProps = {
    imageUrls: string[];
    selectedImageUrl?: string;
    open: boolean;
    onClose: () => void;
};
const ImageGalleryDialog: FC<ImageGalleryDialogProps> = ({
    imageUrls,
    selectedImageUrl,
    open,
    onClose,
}: ImageGalleryDialogProps) => {
    const { t: translate } = useTranslation(['common', 'order-event']);
    const [currentImgSrc, setCurrentImgSrc] = useState<string>();
    const [imageLoading, setImageLoading] = useState<boolean>(true);

    useEffect(() => {
        setImageLoading(true);
        if (selectedImageUrl && selectedImageUrl.length > 0) {
            setCurrentImgSrc(selectedImageUrl);
        } else if (imageUrls.length > 0) {
            setCurrentImgSrc(imageUrls[0]);
        }
    }, [selectedImageUrl]);

    const onImageClick = (url: string) => {
        if (currentImgSrc !== url) {
            setImageLoading(true);
            setCurrentImgSrc(url);
        }
    };

    const imageLoaded = () => {
        setImageLoading(false);
    };

    return (
        <Dialog maxWidth={false} fullWidth open={open} onClose={onClose}>
            <DialogTitle>{translate('order-event:IMAGES')}</DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item md={9}>
                        <Box sx={{ backgroundColor: '#111', height: '100%' }} mr={2} display="flex">
                            <Box sx={{ margin: 'auto', maxHeight: '70vh' }}>
                                {imageLoading ? <LinearProgress color="secondary" /> : undefined}
                                <img
                                    style={{
                                        maxHeight: '70vh',
                                        maxWidth: '100%',
                                        opacity: imageLoading ? 0.3 : 1,
                                    }}
                                    src={currentImgSrc}
                                    loading="lazy"
                                    onLoad={imageLoaded}
                                />
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item md={3}>
                        <Paper variant="outlined" square>
                            <ImageList cols={2} sx={{ margin: 0, overflowY: 'scroll', maxHeight: '70vh' }}>
                                {imageUrls.map((url, index) => (
                                    <ImageListItem key={index} onClick={() => onImageClick(url)}>
                                        <img
                                            src={url}
                                            srcSet={url}
                                            alt={url}
                                            style={{ cursor: 'pointer', height: 140 }}
                                            loading="lazy"
                                        />
                                    </ImageListItem>
                                ))}
                            </ImageList>
                        </Paper>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('common:CLOSE')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImageGalleryDialog;
